import { HttpService } from '../../../App/services/http-service';
import { ProcessItem, ProcessItemOptions } from '../model/process-item';

/**
 * @ngdoc service
 * @kind function
 * @name mx.shell.BackgroundProcessProvider
 * @module mx.shell
 *
 * @description
 * Represents an interface for injection concrete implementation of the Background Process Provider.
 * The Application has to provide the concrete implementation of this service, which is registered in the di.map object.
 */
export class MxBackgroundProcessProvider {
	static $inject = ['mx.SolutionBuilderAgent.Http'];
	constructor(private readonly http: HttpService) {}

	/**
	 * @ngdoc method
	 * @name mx.shell.BackgroundProcessProvider#load
	 *
	 * @description
	 * Loads Background Processes.
	 *
	 * @returns {promise} Resolved as an array of background process items
	 */
	public async load(): Promise<Array<ProcessItem>> {
		let data = (await this.http.get<Array<ProcessItemOptions>>('api/backgroundprocess')) || [];

		const isJSON = (value: string) => {
			try {
				JSON.parse(value);
				return true;
			} catch (e) {
				return false;
			}
		};
		//if StatusDetails or OperationName is a JSON, then it is a parametrised strings; it is available only in ModernUI, so filter them for classic
		data = data.filter((item) => !isJSON(item.StatusDetails) && !isJSON(item.OperationName));

		return data.map((item) => new ProcessItem(item));
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.BackgroundProcessProvider#cancelProcess
	 *
	 * @description
	 * Cancels existing process.
	 *
	 * @param {object} item - id of process to be deleted
	 * @returns {promise}
	 */
	public async cancelProcess(item: ProcessItem): Promise<void> {
		await this.http.post('api/backgroundprocess/' + item.id + '/cancel');
		if (item.cancellationUrl) {
			const reg = /(https?:\/\/[\w.]+\/)(.+)/gi;
			const result = reg.exec(item.cancellationUrl);
			if (result) {
				await this.http.host(result[1]).get(result[2]);
			}
		}
	}
}
